import { SetGetInformationUsers } from './thunk/setGetInformationUsers';
import {SetGetCountOnline} from './thunk/setGetCountOnline';
import {SetGetDetalization} from './thunk/setGetDetalization';

export const Thunks = {
    SetGetCountOnline,
    SetGetDetalization,
    SetGetInformationUsers
}